<div tiimeForm class="document-request-form">
  <div tiimeFormColumn>
    <tiime-alert primary>
      Vous allez créer une demande de document. Votre client pourra donc la consulter et interagir avec depuis ses
      applications. Il n'est possible d'avoir qu'une seule demande de document par type.
    </tiime-alert>
    <app-document-request-type-select
      [control]="documentRequestForm().controls.moduleType"
      [selectData]="DocumentRequestModuleTypeArray"
      [errorMessage]="documentRequestForm().moduleTypeErrorMessage"
    ></app-document-request-type-select>
    <tiime-input-container label="Exercice" class="input-container-with-tooltip">
      <input readonly disabled [value]="accountingPeriodString()" />
      <mat-icon
        class="tooltip-icon"
        fontSet="fontastic"
        fontIcon="icon-ic-info"
        tiimeTooltip="La demande sera réalisée sur l’exercice en cours."
      ></mat-icon>
    </tiime-input-container>
    <tiime-input-container
      contentId="document-request-title"
      label="Titre"
      [errorMessage]="documentRequestForm().titleErrorMessage?.message"
    >
      <input
        id="document-request-title"
        placeholder="Titre"
        [formControl]="documentRequestForm().controls.title"
        maxlength="255"
      />
    </tiime-input-container>
    <tiime-input-container
      contentId="document-request-description"
      label="Description"
      [errorMessage]="documentRequestForm().descriptionErrorMessage?.message"
    >
      <textarea
        id="document-request-description"
        placeholder="Description"
        [formControl]="documentRequestForm().controls.description"
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
      ></textarea>
    </tiime-input-container>
    @if (
      documentRequestForm().file.value || documentRequestForm().moduleType.value === DocumentRequestModuleType.CUSTOM
    ) {
      <tiime-input-container label="Modèle" class="input-container-with-tooltip">
        <input readonly disabled [value]="documentRequestForm().file.value?.name" />
        @if (documentRequestForm().file.value?.uuid) {
          <mat-icon class="file-input-icon" tiimeTooltip="Télécharger le modèle" (click)="onDownloadTemplateClick()">
            download
          </mat-icon>
        } @else if (
          panelMode() === 'Creation' && documentRequestForm().moduleType.value === DocumentRequestModuleType.CUSTOM
        ) {
          @if (documentRequestForm().file.value) {
            <mat-icon
              class="file-input-icon offsetted"
              tiimeTooltip="Supprimer le modèle"
              (click)="onFileDeleted.emit()"
            >
              close
            </mat-icon>
          } @else {
            <mat-icon class="file-input-icon offsetted" tiimeTooltip="Ajouter un modèle" (click)="file.click()">
              upload
            </mat-icon>
          }
          @if (
            panelMode() === 'Creation' && documentRequestForm().moduleType.value === DocumentRequestModuleType.CUSTOM
          ) {
            <mat-icon
              class="tooltip-icon"
              fontSet="fontastic"
              fontIcon="icon-ic-info"
              tiimeTooltip="Le modèle doit être inférieur à 8 mo."
            ></mat-icon>
          }
        }
        <input
          hidden
          #file
          type="file"
          [accept]="acceptedTypes().join()"
          (click)="$event.stopImmediatePropagation()"
          (change)="onFileSelected.emit(file.files[0])"
        />
      </tiime-input-container>
    }
  </div>
</div>
